import api from '@/utils/api'

const LOCAL_STORAGE_KEY = 'currentRegionSlug'

// Minimal hardcoded stubs so the toolbar/copy can render correctly on first
// paint, before /v1/regions has come back. Slugs are stable, so the visible
// region name never flickers. Marketing copy/assets live in src/copy/regionCopy.js
// keyed by slug; do NOT add content fields here.
const KNOWN_REGIONS = {
  memphis: { id: null, slug: 'memphis', name: 'Memphis' },
  'south-walton': { id: null, slug: 'south-walton', name: 'South Walton' },
}
const DEFAULT_SLUG = 'memphis'

function readInitialSlug() {
  try {
    const stored = window.localStorage.getItem(LOCAL_STORAGE_KEY)
    if (stored && KNOWN_REGIONS[stored]) return stored
  } catch (_err) {
    // localStorage can throw in private mode; fall through to default
  }
  return DEFAULT_SLUG
}

function initialCurrent() {
  return KNOWN_REGIONS[readInitialSlug()]
}

export default {
  namespaced: true,
  state: {
    current: initialCurrent(),
    available: Object.values(KNOWN_REGIONS),
    availableLoaded: false,
  },
  getters: {
    current(state) { return state.current },
    available(state) { return state.available },
    availableLoaded(state) { return state.availableLoaded },
  },
  mutations: {
    setCurrent(state, region) {
      state.current = region
      try {
        window.localStorage.setItem(LOCAL_STORAGE_KEY, region.slug)
      } catch (_err) {
        // ignore localStorage failures
      }
    },
    setAvailable(state, regions) {
      state.available = regions
      state.availableLoaded = true
    },
  },
  actions: {
    setRegion({ commit, state }, slug) {
      const found = state.available.find(r => r.slug === slug)
      if (!found) return
      commit('setCurrent', found)
    },
    async loadAvailable({ commit, state }) {
      try {
        const { data } = await api.get('/regions')
        const regions = (data && data.data && data.data.regions) || []
        if (regions.length === 0) return
        commit('setAvailable', regions)
        // Replace `current` with the canonical row (now has the real id) — slug stays the same.
        const refreshed = regions.find(r => r.slug === state.current.slug)
        if (refreshed) commit('setCurrent', refreshed)
      } catch (err) {
        console.error('Failed to load regions', err)
      }
    },
  },
}
